<template>
  <div>
    <v-card elevation="1" max-width="90%" class="profile-data loginSettings">
      <v-card-text>
        <div class="details">
          <v-form v-model="valid" ref="emailForm">
            <v-row>
              <v-col cols="12" sm="4" v-if="!editEmail && !editPass">
                <p class="main-color">
                  <strong>{{ $t("email") }}</strong>
                </p>
              </v-col>
              <v-col cols="12" sm="4" v-if="!editEmail && !editPass"
                ><p>
                  <strong>{{ login.email }}</strong>
                </p></v-col
              >
              <v-col cols="12" sm="4" v-if="!editEmail && !editPass"
                ><p
                  class="main-color changeEmail"
                  style="cursor:pointer"
                  @click="openEditMode('email')"
                >
                  <strong>{{ $t("Change Email") }} </strong>
                </p></v-col
              >
              <v-col cols="12" sm="6" v-if="editEmail">
                <p class="main-color">
                  <strong>{{ $t("email") }}</strong>
                </p>
              </v-col>
              <v-col v-if="editEmail" cols="12" sm="6">
                <v-text-field
                  solo
                  v-model.trim="updateObject.email"
                  :rules="[validationRules.required, validationRules.email]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="editEmail">
              <v-col cols="12" sm="6">
                <p class="main-color">
                  <strong>{{ $t("password") }}</strong>
                </p>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  :append-icon="
                    toggleCurrentPassword ? 'mdi-eye-off' : 'mdi-eye'
                  "
                  @click:append="
                    () => (toggleCurrentPassword = !toggleCurrentPassword)
                  "
                  :type="toggleCurrentPassword ? 'password' : 'text'"
                  :rules="[validationRules.required, validationRules.password]"
                  solo
                  v-model.trim="updateObject.current_password"
                  class="password"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-form v-model="valid" ref="passForm">
            <v-row v-if="!editEmail && !editPass">
              <v-col cols="12" sm="4">
                <p class="main-color">
                  <strong>{{ $t("password") }}</strong>
                </p>
              </v-col>
              <v-col cols="12" sm="4" v-if="!editEmail && !editPass"
                ><p>
                  <strong>
                    <v-icon color="gray" small>brightness_1 </v-icon>
                    <v-icon color="gray" small>brightness_1 </v-icon>
                    <v-icon color="gray" small>brightness_1 </v-icon>
                    <v-icon color="gray" small>brightness_1 </v-icon>
                    <v-icon color="gray" small>brightness_1 </v-icon>
                    <v-icon color="gray" small>brightness_1 </v-icon>
                  </strong>
                </p></v-col
              >

              <v-col cols="12" sm="4" v-if="!editEmail && !editPass"
                ><p
                  class="main-color changePassword"
                  style="cursor:pointer"
                  @click="openEditMode('password')"
                >
                  <strong> {{ $t("Change Password") }}</strong>
                </p></v-col
              >
            </v-row>

            <v-row v-if="editPass">
              <v-col cols="12" sm="3">
                <p class="main-color">
                  <strong>{{ $t("Current Password") }}</strong>
                </p>
              </v-col>
              <v-col>
                <v-text-field
                  solo
                  v-model.trim="updateObject.current_password"
                  :append-icon="
                    toggleCurrentPassword ? 'mdi-eye-off' : 'mdi-eye'
                  "
                  @click:append="
                    () => (toggleCurrentPassword = !toggleCurrentPassword)
                  "
                  :type="toggleCurrentPassword ? 'password' : 'text'"
                  :rules="[validationRules.required, validationRules.password]"
                  class="password"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="editPass">
              <v-col cols="12" sm="3">
                <p class="main-color">
                  <strong>{{ $t("new_password") }}</strong>
                </p>
              </v-col>
              <v-col>
                <v-text-field
                  solo
                  v-model.trim="updateObject.new_password"
                  :append-icon="togglePassword ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append="() => (togglePassword = !togglePassword)"
                  :type="togglePassword ? 'password' : 'text'"
                  :rules="[validationRules.required, validationRules.password]"
                  class="password"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="editEmail || editPass">
              <v-col :class="locale == 'en' ? 'text-right' : 'text-left'">
                <v-btn
                  class="primary-btn"
                  @click="update"
                  :loading="loading"
                  :disabled="loading"
                  >{{ $t("Update") }}</v-btn
                >
                <v-btn class="gray-btn" @click="cancelEdit">
                  {{ $t("Cancel") }}</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from "../mixins/validationMixin";

export default {
  name: "studentLoginSetting",
  props: ["login"],
  mixins: [validationMixin],

  data() {
    return {
      toggleCurrentPassword: true,
      togglePassword: true,
      loading: false,
      updateObject: {
        email: this.login.email,
        current_password: "",
        new_password: ""
      },
      editEmail: false,
      editPass: false,
      valid: false
    };
  },
  methods: {
    openEditMode(field) {
      if (field == "email") {
        this.updateObject = {
          email: this.login.email,
          current_password: "",
          type: "Student"
        };
        this.editEmail = true;
      } else {
        this.updateObject = {
          current_password: "",
          new_password: "",
          type: "Student"
        };
        this.editPass = true;
      }
    },
    cancelEdit() {
      this.editEmail = false;
      this.editPass = false;
    },
    update() {
      if (this.valid == false) {
        if (this.editEmail) {
          this.$refs.emailForm.validate();
        } else {
          this.$refs.passForm.validate();
        }
      } else {
        this.loading = true;
        this.$http
          .post(
            this.getApiUrl + "/profile/credentials/update",
            this.updateObject,
            {
              headers: {
                locale: localStorage.locale,
                Authorization: "Bearer " + localStorage.token
              }
            }
          )
          .then(Response => {
            this.loading = false;
            if (Response.data.status.error) {
              // emit update to parent
              this.$emit(
                "updated",
                Response.data.status.error,
                Response.data.status.message
              );
            } else {
              this.cancelEdit();
              if (Response.data.data.redirectToVerificationPage) {
                // logout and redirect
                const currentLocale = localStorage.locale;
                localStorage.clear();
                localStorage.locale = currentLocale;
                localStorage.email = Response.data.data.user.email;
                localStorage.registered = true;
                window.location.href = "/activationCode";
              } else {
                // emit update to parent
                this.$emit(
                  "updated",
                  Response.data.status.error,
                  Response.data.status.message
                );
              }
            }
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/_variables.scss";
@import "../assets/styles/_responsive.scss";

.profile-data {
  margin-top: 4rem;
  margin-bottom: 4rem;
  padding: 2rem;
}

.changePassword {
  text-decoration: underline;
}
.changeEmail {
  text-decoration: underline;
}
</style>
